import { render, staticRenderFns } from "./BaseChoice.vue?vue&type=template&id=06805c4e&"
import script from "./BaseChoice.vue?vue&type=script&lang=js&"
export * from "./BaseChoice.vue?vue&type=script&lang=js&"
import style0 from "./BaseChoice.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports